import { render, staticRenderFns } from "./IconMeh.vue?vue&type=template&id=070f0a1e&scoped=true"
import script from "./IconMeh.vue?vue&type=script&lang=js"
export * from "./IconMeh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070f0a1e",
  null
  
)

export default component.exports